<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="师傅id,外键{zb_user.id}" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入师傅id,外键{zb_user.id}" />
      </a-form-model-item>
      <a-form-model-item label="师傅订单id,外键{zb_master_order.id}" prop="masterOrderId" >
        <a-input v-model="form.masterOrderId" placeholder="请输入师傅订单id,外键{zb_master_order.id}" />
      </a-form-model-item>
      <a-form-model-item label="结算金额" prop="money" >
        <a-input v-model="form.money" placeholder="请输入结算金额" />
      </a-form-model-item>
      <a-form-model-item label="结算状态,0-冻结,1-解冻" prop="status" >
      </a-form-model-item>
      <a-form-model-item label="解冻时间" prop="thawTime" >
        <a-date-picker style="width: 100%" v-model="form.thawTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {addSettlement, getSettlement, updateSettlement} from '@/api/master/settlement'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        masterOrderId: null,

        money: null,

        status: 0,

        thawTime: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '师傅id,外键{zb_user.id}不能为空', trigger: 'blur' }
        ],
        masterOrderId: [
          { required: true, message: '师傅订单id,外键{zb_master_order.id}不能为空', trigger: 'blur' }
        ],
        money: [
          { required: true, message: '结算金额不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '结算状态,0-冻结,1-解冻不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        masterOrderId: null,
        money: null,
        status: 0,
        thawTime: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSettlement({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateSettlement(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addSettlement(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
